export default {
  "header.user.editProfile": "修改个人资料",
  "header.user.signOut": "退出登录",
  "header.action.share": "分享应用",
  "header.action.deploy": "部署应用",
  "header.action.current": "当前版本",
};
